import { connect } from 'react-redux';
import Header, { HeaderProps } from '../components/Header';
import { setMicrophone, setShareUnshareScreen, endCall, sendMessage, setHelpClickedState } from '../core/sideEffects';
import { utils } from '../Utils/Utils';
import { Constants } from '../core/constants';
import { State } from '../core/reducers';
import { setVideoDeviceInfo, setAudioDeviceInfo } from '../core/actions/devices';
import { AudioDeviceInfo, VideoDeviceInfo } from '@azure/communication-calling';

const mapStateToProps = (state: State, props: HeaderProps) => ({
    userId: state.sdk.userId,
    actionable:
        state.calls.callState === Constants.INCOMING ||
        state.calls.callState === Constants.RINGING ||
        state.calls.callState === Constants.CONNECTING ||
        state.calls.callState === Constants.CONNECTED,
    mic: state.controls.mic,
    call: state.calls.call,
    shareScreen: state.controls.shareScreen,
    endCall: (): void => {
        state.calls.call && state.contosoClient.user.identity && endCall(state, { forEveryone: false }, state.contosoClient.user.identity);
        props.endCallHandler();
    },
    videoDeviceInfo: state.devices.videoDeviceInfo,
    videoDeviceList: state.devices.videoDeviceList,
    screenWidth: props.screenWidth,
    screenShareStreams: state.streams.screenShareStreams,
    localVideoRendererIsBusy: state.streams.localVideoRendererIsBusy,
    cameraPermission: state.devices.cameraPermission,
    microphonePermission: state.devices.microphonePermission,
    audioDeviceInfo: state.devices.audioDeviceInfo,
    audioDeviceList: state.devices.audioDeviceList,
    setVideoDeviceInfo: setVideoDeviceInfo,
    setAudioDeviceInfo: setAudioDeviceInfo,
    helpClicked: state.controls.HelpClicked,
    SendHelpMessage: props.SendHelpMessage
});

const mapDispatchToProps = (dispatch: any) => ({
    setMic: (mic: boolean): void => dispatch(setMicrophone(mic)),
    setScreenShare: (screenShare: boolean): void => dispatch(setShareUnshareScreen(screenShare)),
    // Only support Desktop -- Chrome | Edge (Chromium) | Safari
    isLocalScreenShareSupportedInBrowser: (): boolean => {
        return (
            !utils.isMobileSession() &&
            (/chrome/i.test(navigator.userAgent.toLowerCase()) || /safari/i.test(navigator.userAgent.toLowerCase()))
        );
    },
    setVideoDeviceInfo: (device: VideoDeviceInfo): void => dispatch(setVideoDeviceInfo(device)),
    setAudioDeviceInfo: (device: AudioDeviceInfo): void => dispatch(setAudioDeviceInfo(device)),
    SendHelpMessage: (helpClicked: boolean): void => {
        if (!helpClicked)
        {
            helpClicked = true;
            dispatch(sendMessage("Hello, I need some assistance!"));
            dispatch(setHelpClickedState(helpClicked));
            setTimeout(() => {
                helpClicked = false;
                dispatch(setHelpClickedState(helpClicked));
            }, 20000);
        }

    }
});

const connector: any = connect(mapStateToProps, mapDispatchToProps);
export default connector(Header);